import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { JobService } from '../../services/job.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-create-job',
    templateUrl: './create-job.component.html',
    styleUrls: ['./create-job.component.css', '../../app.component.css']
})

export class CreateJobComponent implements OnInit, OnDestroy {

    jobForm: FormGroup;
    job: any;

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    gsSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private jobService: JobService,
                private subsidiaryService: SubsidiaryService) {
        this.loadSubsidiaries();
    }

    ngOnInit() {
        this.jobForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            internalNumber: ['', Validators.required],
            baseSalary: ['', Validators.required],
            extraSalary: [0, Validators.required],
            subsidiary: ['', Validators.required]
        });
    }

    onSubmitJob() {
        this.job = this.saveJob();

        this.jobService.postJob(this.job).then(res => {
            this.jobForm.reset();

            this.router.navigate(['/roles_jobs', {outlets: {'tab_job': ['jobs']}}]);
        });
    }

    saveJob() {
        const currentDate = new Date();

        const jobJson = {
            active: true,
            baseSalary: this.jobForm.get('baseSalary').value,
            extraSalary: this.jobForm.get('extraSalary').value,
            createdAt: currentDate,
            description: this.jobForm.get('description').value,
            internalNumber: this.jobForm.get('internalNumber').value,
            name: this.jobForm.get('name').value,
            subsidiaryId: this.subsidiaries[this.jobForm.get('subsidiary').value],
            updatedAt: currentDate
        };

        return jobJson;
    }

    loadSubsidiaries() {
        this.gsSubs = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const data = {};

            for (const idx in tempSubsidiaries) {
                data[tempSubsidiaries[idx].name] = null;

                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.subsidiaries[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

    ngOnDestroy() {
        this.gsSubs.unsubscribe();
    }

}
